module.exports = __webpack_public_path__ + "img/certificate_background.22b1e0d8.jpg";